import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../../../assets/img/img-empty.png';
import _imports_1 from '../../../assets/img/driver.png';
import _imports_2 from '../../../assets/img/package.png';
import _imports_3 from '../../../assets/img/eye-icon.png';
import _imports_4 from '../../../assets/img/persion.png';
import _imports_5 from '../../../assets/img/download.png';
import _imports_6 from '../../../assets/img/date.png';
const _hoisted_1 = {
  class: "list-content",
  ref: "listContentRef"
};
const _hoisted_2 = {
  key: 0,
  class: "contentImg",
  draggable: "false"
};
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  class: "noImg",
  draggable: "false"
};
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: "",
  draggable: "false",
  class: "noImg"
};
const _hoisted_5 = {
  key: 2,
  src: _imports_1,
  class: "logoImg",
  draggable: "false"
};
const _hoisted_6 = {
  key: 3,
  src: _imports_2,
  class: "logoImg",
  draggable: "false"
};
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = {
  class: "title-box"
};
const _hoisted_9 = ["title"];
const _hoisted_10 = ["title"];
const _hoisted_11 = {
  key: 0,
  class: "private"
};
const _hoisted_12 = {
  class: "tag-box"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  class: "text-description"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "ellipsis"
}, "...", -1);
const _hoisted_16 = {
  class: "info-box"
};
const _hoisted_17 = {
  class: "info-left"
};
const _hoisted_18 = {
  class: "info-item"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1);
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  key: 0,
  class: "info-item"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1);
const _hoisted_23 = {
  key: 0,
  class: "info-item"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "date-img"
}, null, -1);
const _hoisted_25 = {
  key: 0,
  class: "info-item"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "date-img"
}, null, -1);
const _hoisted_27 = {
  key: 0,
  class: "info-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.content.thumbUrl !== undefined ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "left lookImg",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.lookBigImg && $options.lookBigImg(...args), ["stop"]))
  }, [$props.content.thumbUrl ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_2, null, 512)), [[_directive_lazy, $props.content.thumbUrl]]) : _createCommentVNode("", true), !$props.content.thumbUrl ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "left lookDoc",
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.lookDocumentation && $options.lookDocumentation(...args), ["stop"]))
  }, [$props.content.driverType && $props.content.driverType.icon ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: _normalizeClass(["icontype", $props.content.driverType.icon])
  }, null, 2)) : (_openBlock(), _createElementBlock("img", _hoisted_4)), $options.getType($props.content) === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), $options.getType($props.content) === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
    class: "title",
    style: _normalizeStyle({
      'max-width': $data.titleWidth + 'px'
    }),
    title: $props.content.name
  }, _toDisplayString($props.content.name || ""), 13, _hoisted_9), _createElementVNode("p", {
    class: "version",
    title: $props.content.version
  }, _toDisplayString($options.getTextEllipsis($props.content.version || "", 10)), 9, _hoisted_10), _createElementVNode("img", {
    src: _imports_3,
    draggable: "false",
    class: "eye",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.handleLook && $options.handleLook(...args), ["stop"]))
  }), !$props.content.open ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("message.Private")), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.content.keywords.replace(/，/g, ',').split(','), (keyword, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [keyword.trim().length ? (_openBlock(), _createElementBlock("div", {
      class: "tag-item",
      key: index,
      style: _normalizeStyle({
        width: $data.tagItemWidth
      }),
      title: keyword.trim()
    }, _toDisplayString(keyword.trim()), 13, _hoisted_13)) : _createCommentVNode("", true)], 64);
  }), 256))]), _createElementVNode("div", {
    class: "text-box",
    style: _normalizeStyle({
      maxHeight: `${$data.boxHeight}px`
    })
  }, [_createElementVNode("p", _hoisted_14, _toDisplayString($props.content.description || ""), 1), $data.contentHeight > $data.boxHeight ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "more",
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.lookMore && $options.lookMore(...args), ["stop"]))
  }, [_hoisted_15, _createVNode(_component_el_link, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.LookMore")), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", {
    title: $props.content.author
  }, _toDisplayString($options.getTextEllipsis($props.content.author || "")), 9, _hoisted_20)]), $props.content.downloadCount !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", null, _toDisplayString($props.content.downloadCount || 0), 1)])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.content.shareStatus === 'Deployed' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", null, _toDisplayString($props.content.deployTime), 1)])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [$props.content.deployTime ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", null, _toDisplayString($props.content.deployTime), 1)])) : _createCommentVNode("", true)], 64))]), $options.allVersion[$props.content.ideVersionCode + ''] ? (_openBlock(), _createElementBlock("p", _hoisted_27, " IDE：" + _toDisplayString($options.allVersion[$props.content.ideVersionCode + ""]) + "+ ", 1)) : _createCommentVNode("", true)])])], 512);
}